module.exports = __webpack_public_path__ + "img/menu-values.7f4c93ba.svg";